const times = (length)=>{
    let values = [];
    for(let i = 0; i < length; i++){
        values.push(i)
    }

    return values
}

export default times


// WEBPACK FOOTER //
// ./lib/helpers/times.js